angular.module('dpw.directives').directive('dpwSelectConversation', [function () {
    return {
        restrict: 'A',
        scope: true,
        templateUrl: 'dpw-select-conversation.directive.html',
        controllerAs: 'ctrl',
        controller: ['$scope', 'conversationTypes', '$element', '$rootScope', 'popup',
            function ($scope, conversationTypes, $element, $rootScope, popup) {
                var self = this;

                self.searchText = '';
                self.results = [];

                self.$onInit = function () {
                    self.results = $scope.config.allRecentConversations;
                };

                self.getAppName = function () {
                    return _.get($scope, 'config.app.displayName');
                };

                self.getResultSectionTitle = function () {
                    return self.searchText ? 'Search results' : 'Recent conversations';
                };

                self.onClose = function () {
                    $scope.config.onClose();
                };

                self.focusOnSearchInput = function () {
                    var searchInput = $element[0].querySelector('.dpw-select-conversation-search-input');

                    if (searchInput) {
                        searchInput.focus();
                    }
                }

                self.onSearchTextChange = function () {
                    self.updateResults(self.searchText);
                };

                self.clearSearchText = function () {
                    self.searchText = '';
                    self.updateResults(self.searchText);
                    self.focusOnSearchInput();
                }

                self.updateResults = function (searchText) {
                    searchText = searchText.trim();

                    if (!searchText) {
                        self.results = $scope.config.allRecentConversations;
                        return;
                    }

                    self.results = _.filter($scope.config.allRecentConversations, function (conversation) {
                        if (!conversation.name) {
                            return false;
                        }

                        return conversation.name.toLowerCase().indexOf(searchText.toLowerCase()) > -1;
                    });
                };

                self.isMeChat = function (conversation) {
                    return conversation.type === conversationTypes.PERSONAL;
                };

                self.onSelect = function (conversation) {
                    var newScope = $rootScope.$new();

                    newScope.config = {
                        app: $scope.config.app,
                        groupId: conversation.id,
                        conversationName: conversation.name,
                        onClose: function () {
                            newScope.$destroy();
                        }
                    };

                    popup({
                        scope: newScope,
                        directiveName: 'dpw-set-up-app',
                        showHeader: false,
                        showCloseBtn: false,
                        extraClass: 'dpw-set-up-app-popup'
                    });

                    $scope.config.onClose();
                };
        }],
        link: function (scope) {
            scope.ctrl.focusOnSearchInput();
        }
    };
}]);
